<template>
  <div id="picture-container" class="mt-5">
    <BlockUI v-if="loading">
      <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
    </BlockUI>

    <div v-if="!isEdit && info.pictureURLs.length">
      <div id="picture-header">
        <h3>{{ $t("utils.spaces.pictures.title") }}</h3>
      </div>
      <div class="d-flex flex-row file-gallery text-center mt-3 gap-2">
        <div
          class="picture"
          v-for="(picture, index) in info.pictureURLs"
          :key="index"
        >
          <img :src="picture" />
        </div>
      </div>
    </div>

    <div v-if="isEdit">
      <div id="picture-header" class="d-flex justify-content-between">
        <div>
        <h3>{{ $t("utils.spaces.pictures.title") }}</h3>
        </div>
        <div>
        <h3>Min 4/Max 6</h3>
        </div>
      </div>
       <div class="d-flex flex-row file-gallery text-center mt-3 gap-2">
        <div
          class="picture"
          v-for="(picture, index) in info.pictureURLs"
          :key="index"
        >
          <img :src="picture" />
          <div class="delete">
           <img src="@/assets/images/icons/delete.svg" class="mb-1" @click="deleteImage(picture, index)">
          </div>
        </div>
        <div class="custom-file-upload" v-if="info.pictureURLs.length < 6">
          <label
            for="file-upload"
            id="upload-text"
            class="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
          >
          <img
            src="@/assets/images/icon-loading.svg"
            alt="upload"
            id="upload-image"
            class="mb-3"
          />
          </label>
          <input
            id="file-upload"
            type="file"
            accept="image/*"
            @change="setPictures"
            multiple
            class="d-none"
          />
          </div>
      </div>
    </div>
    <MessageBanner
      :message="error"
      :type="'error'"
      :classes="['position-bottom-center']"
      v-if="error !== ''"
    />
  </div>
</template>

<script>
import FileService from "@/services/file";

export default {
  props: ["info", "isEdit", "currentUser"],
  data() {
    return {
      loading: false,
      error: ""
    };
  },
  methods: {
    setPictures(event) {
      setTimeout(async () => {
        this.loading = true;
        if (
          this.$props.info.pictureURLs.length < 6 &&
          this.$props.info.pictureURLs.length + event.srcElement.files.length <=
            6
        ) {
          this.$props.info.pictureURLs.push(
            ...(await FileService.uploadImage(
              event.target.files,
              this.$props.currentUser.id
            ))
          );
          this.loading = false;
        } else {
          this.error = this.$t("utils.spaces.pictures.message");
          setTimeout(() => {
            this.error = "";
          }, 2500);
          this.loading = false;
        }
      }, 0);
    },
    deleteImage(picture, index) {
      setTimeout(async () => {
        const response = await FileService.deleteImage(picture);
        if (response != null) {
            this.error = response;
            setTimeout(() => {
              this.error = "";
            }, 2500)
        } else {
            this.$props.info.pictureURLs.splice(index, 1)
        }
      }, 0);
    }
 }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/fonts";

#picture-header {
  width: 700px;
  h3 {
    font-family: $inter;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #767676;
  }
}

.picture {
  position: relative;
  img {
    width: 135px;
    height: 150px;
    object-fit: cover;
  }

  .delete {
    width: 24px;
    height: 24px;
    background-color: #dadada;
    position: absolute;
    bottom: 2px;
    right: 2px;
    z-index: 100;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
      padding-bottom: 1%;
    }
  }
}

.custom-file-upload {
  width: 135px;
  height: 150px;
  border: 1px dashed #000000;
  box-sizing: border-box;
  display: inline-block;
  background-color: #e7e7e7;

  #upload-text {
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }

  #upload-image {
    width: 38px;
    height: 26px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/info/components/Pictures.vue